export default {
  VIETNAM: 'vi',
  ENGLISH: 'en',
};
